export const and = (...args: (string | number | boolean | undefined | null)[]): boolean =>
  args.reduce((reducer: boolean, item: any) => {
    if (!Boolean(item)) {
      reducer = false;
    }
    return reducer;
  }, true);
